import { key } from 'core-ts-types';
import * as _4 from 'lodash4';

export class Grade {
  id: key = 0;
  nk: string;
  grade_letter: string;
  grade_points: number;

  constructor(grade: Partial<Grade>) {
    _4.merge(this, grade);
  }

  static build(grade: Grade): Grade {
    return new Grade(grade);
  }
}



// WEBPACK FOOTER //
// ./app/lib/transfer/builders/grade_builder.ts